import { Skeleton, Dialog, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";

import CloseIcon from "@mui/icons-material/Close";

const SmartImage = ({
  src,
  alt = "image",
  fallback,
  showSkeleton = true,
  skeletonVariant = "circular",
  animation = "wave",
  enableFullscreen = false,
  hasCircle = false,
  ...rest
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);

  // Reset when image source changes
  useEffect(() => {
    setHasError(false);
    setIsLoaded(false);
    setFullscreenOpen(false);
  }, [src]);

  const isInvalidSrc = !src || src.trim() === "";

  if (hasError || isInvalidSrc) {
    return fallback ?? null;
  }

  const canOpenFullscreen = enableFullscreen && isLoaded && !hasError && src;
  const handleOpenFullscreen = () => {
    if (canOpenFullscreen) {
      setFullscreenOpen(true);
    }
  };

  return (
    <>
      {!isLoaded && showSkeleton && (
        <Skeleton
          variant={skeletonVariant}
          animation={animation}
          sx={{
            bgcolor: "rgba(0,0,0,0.15)",
            width: "100%",
            height: "100%",
            borderRadius: 0,
          }}
        />
      )}
      {src && (
        <img
          src={src}
          alt={alt}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          onClick={handleOpenFullscreen}
          style={{
            cursor: canOpenFullscreen ? "pointer" : "default",
            ...rest.style,
          }}
          {...rest}
        />
      )}

      {/* Fullscreen dialog */}
      {canOpenFullscreen && (
        <Dialog
          open={fullscreenOpen}
          onClose={() => setFullscreenOpen(false)}
          fullScreen
          PaperProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            },
          }}
        >
          <IconButton
            onClick={() => setFullscreenOpen(false)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "white",
              zIndex: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={src}
            alt={alt}
             style={
              hasCircle
                ? {
                    width: "min(90vw, 90vh)",
                    height: "min(90vw, 90vh)",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }
                : {
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                    objectFit: "contain",
                    borderRadius: 8,
                  }
            }
          />
        </Dialog>
      )}
    </>
  );
};

export default SmartImage;
